// export enum Consts {
//   API_URL_LOCAL = "https://localhost:44368/api",
//   // API_URL_PRODUCTION = "https://nxb-api.cnttvietnam.com.vn/api",
//   API_URL_PRODUCTION = "https://nxb.cnttvietnam.com.vn/api",
//   BACKEND_PROTOCOL = "http://",
//   // BACKEND_URL_LOCAL = "localhost:4200",
//   BACKEND_URL_LOCAL = "https://localhost:44368/api",
//   BACKEND_URL_PRODUCTION = "https://nxb-api.cnttvietnam.com.vn/"
// }

// export enum Consts {
//   API_URL_LOCAL = "https://localhost:44368/api",
//   // API_URL_PRODUCTION = "https://nxb-api.cnttvietnam.com.vn/api",
//   API_URL_PRODUCTION = "https://fauna-flora.vap.ac.vn/api",
//   BACKEND_PROTOCOL = "http://",
//   // BACKEND_URL_LOCAL = "localhost:4200",
//   BACKEND_URL_LOCAL = "https://localhost:44368/api",
//   BACKEND_URL_PRODUCTION = "https://nxb.cnttvietnam.com.vn/"
// }
export enum Consts {
  API_URL_LOCAL = "https://localhost:5001/api",
  API_URL_PRODUCTION = "/api",
  BACKEND_PROTOCOL = "http://",
  // BACKEND_URL_LOCAL = "localhost:4200",
  BACKEND_URL_LOCAL = "https://localhost:44368/api",
  BACKEND_URL_PRODUCTION = "https://nxb.cnttvietnam.com.vn/"
}
// export enum Consts {
//   API_URL_LOCAL = "https://localhost:5001/api",
//   // API_URL_PRODUCTION = "https://nxb-api.cnttvietnam.com.vn/api",
//   API_URL_PRODUCTION = "http://nxb.digipro.com.vn/api",
//   BACKEND_PROTOCOL = "http://",
//   // BACKEND_URL_LOCAL = "localhost:4200",
//   BACKEND_URL_LOCAL = "https://localhost:5001/api",
//   BACKEND_URL_PRODUCTION = "https://nxb.cnttvietnam.com.vn/"
// }

// export enum Consts {
//   API_URL_LOCAL = "https://localhost:44368/api",
//   API_URL_PRODUCTION = "https://nxbtest.cnttvietnam.com.vn/api",
//   // API_URL_PRODUCTION = "http://fauna-flora.vap.ac.vn/api",
//   BACKEND_PROTOCOL = "http://",
//   // BACKEND_URL_LOCAL = "localhost:4200",
//   BACKEND_URL_LOCAL = "https://localhost:44368/api",
//   BACKEND_URL_PRODUCTION = "https://nxbtest.cnttvietnam.com.vn/"

// }

// export enum Consts {
//   API_URL_LOCAL = "https://localhost:44368/api",
//   // API_URL_PRODUCTION = "https://nxb-api.cnttvietnam.com.vn/api",
//   API_URL_PRODUCTION = "http://nxb.cntt.com.vn/api",
//   BACKEND_PROTOCOL = "http://",
//   // BACKEND_URL_LOCAL = "localhost:4200",
//   BACKEND_URL_LOCAL = "https://localhost:44368/api",
//   BACKEND_URL_PRODUCTION = "http://nxb.cntt.com.vn/"
// }
